import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import {VStack} from '../../layout/layout.styled';

export const ContentSection = styled(VStack)`
  padding-top: 15px;
  padding-bottom: 15px;
  padding-left: 50px;
  padding-right: 50px;
`;

export const HighlightSection = styled(ContentSection)`
  background-color: white;
  flex-direction: row;
`;

export const HighlightHeading = styled(Typography)`
  color: #076CAC;
  font-size: 13px;
`;
